import angular from 'angular';

angular.module('neurotecAbisWebClientApp').filter('precision', [function () {
	return function (input, threshold) {
		return input.toPrecision(threshold);
	};
}]);
